import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function SystemTaroffTaroffCollectRequestsEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formPeikId, setFormPeikId] = useState(null);
    const [formPeikIdOptions, setFormPeikIdOptions] = useState([]);
    useEffect(() => {
        postData(
            '/api/panel/page/system-taroff-taroff-collect-requests-edit/select-data/peik-id'
        ).then((response) => {
            setFormPeikIdOptions(response.data);
        });
    }, []);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/system-taroff-taroff-collect-requests-edit/save-data', {
            id: allProps['taroff-collect-requests-id'],
            title: formTitle,
            peik_id: formPeikId,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/system-taroff-taroff-collect-requests-edit/form-data', {
            id: allProps['taroff-collect-requests-id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormPeikId(response.data.peik_id);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش درخواست</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'پیک'}
                            options={formPeikIdOptions}
                            value={formPeikId}
                            onChange={setFormPeikId}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
